export const getRenewalSowMessage = {
  error: 'Failed to fetch renewal SOW Date item',
};
